import {Back, Col, Row} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// components
import Document from "./document";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import ReservationsService from "../../../../services/ReservationsService";
import Store from "../../../../stores";
import Axios, {IAxiosConfig} from "../../../../core/Axios";

export default observer(function VerificationPage2() {
    const navigate = useNavigate();
    const [reservations, setReservations] = useState<any>();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const f = async () => {
            const phone = searchParams.get("phone");
            let num = Number(phone);

            const response: any = await ReservationsService.getReservationsByPnone(
                {
                    phone_number: num,
                    status: _.isEqual(Store.reservations.activeKey, "activation") ? "activated" : ""
                },
                true
            );

            setReservations(_.get(response, "items[0]"));
        };
        f();
    }, []);

    return (
        <>
            <Row justify="center" gutter={32} className="back-black">
                <Back
                    navigate={async () => {
                        await Axios({
                            url: "/reservations/passport",
                            method: "PUT",
                            data: {
                                lastname: _.get(reservations, "phone.abonentPassport.firstname"),
                                firstname: _.get(reservations, "phone.abonentPassport.firstname"),
                                patroname: _.get(reservations, "phone.abonentPassport.patroname"),
                                birthday: _.get(reservations, "phone.abonentPassport.birthday"),
                                gender: _.get(reservations, "phone.abonentPassport.gender"),
                                birth_place_name: _.get(
                                    reservations,
                                    "phone.abonentPassport.birth_place_name"
                                ),
                                document_series: _.isEqual(
                                    _.get(reservations, "phone.abonentPassport.document_type"),
                                    "domestic"
                                )
                                    ? _.get(reservations, "phone.abonentPassport.document_series")
                                    : "",
                                passport_nomer: _.get(
                                    reservations,
                                    "phone.abonentPassport.passport_nomer"
                                ),
                                division_code: _.isEqual(
                                    _.get(reservations, "phone.abonentPassport.document_type"),
                                    "domestic"
                                )
                                    ? _.get(reservations, "phone.abonentPassport.division_code")
                                    : "",
                                passport_kogda_vidan: _.get(
                                    reservations,
                                    "phone.abonentPassport.passport_kogda_vidan"
                                ),
                                passport_vidan: _.get(
                                    reservations,
                                    "phone.abonentPassport.passport_vidan"
                                ),
                                place_name: _.get(reservations, "phone.abonentPassport.place_name"),
                                street_name: _.get(
                                    reservations,
                                    "phone.abonentPassport.street_name"
                                ),
                                house: _.get(reservations, "phone.abonentPassport.house"),
                                building_name: _.get(
                                    reservations,
                                    "phone.abonentPassport.building_name"
                                ),
                                apartment_name: _.get(
                                    reservations,
                                    "phone.abonentPassport.apartment_name"
                                ),
                                imei: _.isEqual(
                                    _.get(reservations, "phone.abonentPassport.document_type"),
                                    "domestic"
                                )
                                    ? "-"
                                    : _.get(reservations, "phone.abonentPassport.imei"),
                                phone: _.get(reservations, "phone_number"),
                                status: "declined"
                            }
                        } as IAxiosConfig);

                        navigate(
                            `/signature/step1?id=${_.get(reservations, "tariff.id")}&phone=${_.get(
                                reservations,
                                "phone_number"
                            )}`
                        );
                    }}
                >
                    Назад
                </Back>

                <Col lg={{span: 24}} xs={{span: 24}}>
                    <Document reservations={reservations} />
                </Col>
            </Row>
        </>
    );
});
